import { useEffect } from "react";

export default function AddToCartAnimation({ image, start, end, onDone }) {
  useEffect(() => {
    const el = document.createElement("img");
    el.src = image;

    el.style.position = "fixed";
    el.style.left = start.x + "px";
    el.style.top = start.y + "px";
    el.style.width = "80px";
    el.style.height = "80px";
    el.style.borderRadius = "10px";
    el.style.zIndex = "9999";
    el.style.transition = "all 0.8s cubic-bezier(0.4, 0, 0.2, 1)";

    document.body.appendChild(el);

    const moveTimer = setTimeout(() => {
      el.style.left = end.x + "px";
      el.style.top = end.y + "px";
      el.style.width = "20px";
      el.style.height = "20px";
      el.style.opacity = "0.5";
    }, 50);

    const cleanupTimer = setTimeout(() => {
      el.remove();
      onDone && onDone();
    }, 900);

    return () => {
      clearTimeout(moveTimer);
      clearTimeout(cleanupTimer);
      if (el.isConnected) {
        el.remove();
      }
    };
  }, [end.x, end.y, image, onDone, start.x, start.y]);

  return null;
}